import { queryClient } from '../../main';

/**
 * Refresca todas las listas que enseñan quién paga y cuánto: SEPA, Otros pagos,
 * el desplegable de pagadores y las suscripciones.
 *
 * Llamarla después de cualquier cosa que cambie un cliente, su suscripción o su
 * importe (inscribir, baja, restaurar, editar suscripción, plazas, tarifas). La
 * lista SEPA se cachea 5 minutos y no se recarga al volver a la pestaña: sin
 * esto, una domiciliación nueva no aparecía en SEPA hasta recargar la página.
 */
export const invalidarListasDeCobro = () => {
    for (const key of ['sepa-clients', 'clients-subscriptions', 'clients-without-beneficiary', 'subscriptions', 'clients']) {
        queryClient.invalidateQueries({ queryKey: [key] });
    }
};
